import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import queryparse from 'tricks/string/queryparse';
import { useFetchUserProfile } from 'actions/userProfile';
import ContactFormModal from 'screens/ContactFormModal';
import CompleteProfileModal from './CompleteProfileModal';
import { jsx as _jsx } from "react/jsx-runtime";
function GlobalModals() {
  var navigate = useNavigate();
  var location = useLocation();
  var searchParams = queryparse(location.search);
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data,
    isLoading = _useFetchUserProfile.isLoading;
  function removeModalQuery() {
    navigate(createLocation(location, {
      modal: undefined
    }));
  }
  if (searchParams.modal === 'contact-form') {
    return /*#__PURE__*/_jsx(ContactFormModal, {
      onClose: removeModalQuery
    });
  } else if (searchParams.modal === 'complete-profile') {
    if (!isLoading && userProfile) {
      return /*#__PURE__*/_jsx(CompleteProfileModal, {
        onClose: removeModalQuery,
        userProfile: userProfile
      });
    } else {
      return null;
    }
  }
  return null;
}
export default GlobalModals;